import axios from 'axios'
import router from '@/router'
import queryString from 'query-string'
import { getCookie,removeCookie ,setCookie } from '@/utils'
import API from '@/api.js'

axios.interceptors.request.use(
  config => {
    if (getCookie('userData')) {
			config.headers['Authorization'] = 'Bearer ' + JSON.parse(getCookie('userData')).accessToken // 让每个请求携带自定义token 请根据实际情况自行修改
		}
    config.headers['tenant-id'] = 1
		return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

function handleAuthorized () {
  removeCookie('userData')
  router.push({name:"Login"})
}

// 是否正在刷新中
let isRefreshToken = false
// 请求队列
let requestList = []

const refreshToken = async () => {
  axios.defaults.headers.common['tenant-id'] = 1
  return await axios.post(API.ApiRefreshToken + '?refreshToken=' + JSON.parse(getCookie('userData')).refreshToken)
}

// response 拦截器
axios.interceptors.response.use(
  async response => {
    /**
     * status为非20000是抛错 可结合自己业务进行修改
     */
		const res = response.data
    const config = response.config
		// 401:Token 过期了;
		if (res.code === 401) {
			
      // 如果未认证，并且未进行刷新令牌，说明可能是访问令牌过期了
      if (!isRefreshToken) {
        isRefreshToken = true
        // 2. 进行刷新访问令牌
        try {
          const refreshTokenRes = await refreshToken()
          // 2.1 刷新成功，则回放队列的请求 + 当前请求
          setCookie('userData', (await refreshTokenRes).data)
          config.headers['Authorization'] = 'Bearer ' + JSON.parse(getCookie('userData')).accessToken
          requestList.forEach((cb) => {
            cb()
          })
          requestList = []
          return service(config)
        } catch (e) {
          // 为什么需要 catch 异常呢？刷新失败时，请求因为 Promise.reject 触发异常。
          // 2.2 刷新失败，只回放队列的请求
          requestList.forEach((cb) => {
            cb()
          })
          // 提示是否要登出。即不回放当前请求！不然会形成递归
          return handleAuthorized()
        } finally {
          requestList = []
          isRefreshToken = false
        }
      } else {
        // 添加到队列，等待刷新获取到新的令牌
        return new Promise((resolve) => {
          requestList.push(() => {
            config.headers['Authorization'] = 'Bearer ' + JSON.parse(getCookie('userData')).accessToken // 让每个请求携带自定义token 请根据实际情况自行修改
            resolve(service(config))
          })
        })
      }
		}
		return res
  },
  error => {
    return Promise.reject(error)
  }
)

const ajax = {
	post: function (url, data = {}){
		return new Promise((resolve,reject) => {
			axios.post(url,data)
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
		})
	},
	get: function (url, data = {}){
		return new Promise((resolve,reject) => {
			axios.get(url,{params:data, paramsSerializer: function (params) {  
        return queryString.stringify(params, { arrayFormat: 'repeat' });  
      }})
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
		})
	},
	put: function (url, data = {}){
		return new Promise((resolve,reject) => {
			axios.put(url,queryString.stringify(data))
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
		})
	},
	patch: function (url, data = {}){
		return new Promise((resolve,reject) => {
			axios.patch(url,queryString.stringify(data))
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
		})
	},
	del: function (url, data = {}){
		return new Promise((resolve,reject) => {
			axios.delete(url,{params:data})
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
		})
	}
}

export default ajax;